import jsPDF from "jspdf";

export const generateBalanceSheetPDF = (data) => {
  const doc = new jsPDF();
  const leftX = 20;
  const rightX = 110;
  const pageWidth = doc.internal.pageSize.getWidth();

  // Header Section
  doc.setFontSize(22);
  doc.setTextColor(40, 40, 40);
  doc.text("BALANCE SHEET STATEMENT", pageWidth / 2, 20, { align: "center" });
  
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, 28, { align: "center" });
  
  doc.setLineWidth(0.5);
  doc.line(15, 32, 195, 32); // Top horizontal line

  // Vertical Divider
  doc.setLineWidth(0.1);
  doc.line(105, 40, 105, 160);

  // --- ASSETS (LEFT COLUMN) ---
  doc.setFont(undefined, 'bold');
  doc.setFontSize(12);
  doc.setTextColor(0, 51, 153); // Blue for Assets
  doc.text("DEBIT - ASSETS", leftX, 40);

  doc.setFont(undefined, 'normal');
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.text("Total Principal Investment", leftX, 55);
  doc.text(`Rs. ${data.totalInvestment.toLocaleString()}`, 95, 55, { align: "right" });

  doc.text("Weekly Interest Target", leftX, 65);
  doc.text(`Rs. ${data.weeklyInterestPotential.toLocaleString()}`, 95, 65, { align: "right" });

  // Assets Total
  doc.setLineWidth(0.5);
  doc.line(15, 140, 100, 140);
  doc.setFont(undefined, 'bold');
  doc.text("TOTAL ASSETS", leftX, 150);
  doc.text(`Rs. ${(data.totalInvestment + data.weeklyInterestPotential).toLocaleString()}`, 95, 150, { align: "right" });

  // --- EQUITY (RIGHT COLUMN) ---
  doc.setFont(undefined, 'bold');
  doc.setFontSize(12);
  doc.setTextColor(0, 102, 51); // Green for Equity
  doc.text("CREDIT - EQUITY", rightX, 40);

  doc.setFont(undefined, 'normal');
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.text("Gross Interest Revenue", rightX, 55);
  doc.text(`Rs. ${data.interestGenerated.toLocaleString()}`, 190, 55, { align: "right" });

  doc.setTextColor(200, 0, 0); // Red for Expenses
  doc.text("Total Operating Expenses", rightX, 65);
  doc.text(`-Rs. ${data.totalExpenses.toLocaleString()}`, 190, 65, { align: "right" });

  // Equity Total (Net Profit)
  doc.setTextColor(0, 0, 0);
  doc.setLineWidth(0.5);
  doc.line(110, 140, 195, 140);
  doc.setFont(undefined, 'bold');
  doc.text("TOTAL EQUITY", rightX, 150);
  doc.text(`Rs. ${data.netProfit.toLocaleString()}`, 190, 150, { align: "right" });

  // Footer
  doc.setFontSize(8);
  doc.setFont(undefined, 'italic');
  doc.setTextColor(150, 150, 150);
  doc.text("This is a computer-generated document.", pageWidth / 2, 280, { align: "center" });

  return doc; // Return the object to allow .save() call in component
};